//スクロール アニメーション
$(function () {
  $('a[href^="#"]').on("click", function () {
    var href = $(this).attr("href")
    var target = $(href == "#" || href == "" ? "html" : href)
    var position = target.offset().top
    $("html, body").animate({ scrollTop: position }, 550, "swing")
    return false
  })
})

//jQeury メニューボタン
$(function () {
  // var $nav = $("#navArea")
  // var $btn = $("#toggle_btn")
  // var $mask = $("#mask")
  // var $nav_li = $(".nav_li")
  // var open = "open" // class

  // $btn.on("click", function () {
  //   if (!$nav.hasClass(open)) {
  //     $nav.addClass(open)
  //   } else {
  //     $nav.removeClass(open)
  //   }
  // })
  // // mask close
  // $mask.on("click", function () {
  //   $nav.removeClass(open)
  // })
  // $nav_li.on("click", function () {
  //   $nav.removeClass(open)
  // })

  //サムネイル切り替え

  const images = document.querySelectorAll(".thumb")
  let currentImageIndex = 0

  function displayCurrentImage() {
    document.getElementById("mainImg").src = images[currentImageIndex].src
  }

  images.forEach(function (item, i) {
    item.onclick = function () {
      currentImageIndex = i
      displayCurrentImage()
    }
  })
})
